import {
  ANDROID_APP_URL,
  IOS_APP_URL,
  ANDROID_SJT_APP_URL,
  IOS_SJT_APP_URL,
} from "../constant/index";

export function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone";
  }

  if (/android/i.test(userAgent)) {
    return "Android";
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  }

  return "unknown";
}

export const getStoreLinkByPlatform = (selectedApp, platform) => {
  if (selectedApp === "sjt") {
    return platform === "android" ? ANDROID_SJT_APP_URL : IOS_SJT_APP_URL;
  } else {
    return platform === "android" ? ANDROID_APP_URL : IOS_APP_URL;
  }
};

export const getStoreUrl = (selectedApp) => {
  if (selectedApp === "sjt") {
    return getMobileOperatingSystem() === "Android"
      ? ANDROID_SJT_APP_URL
      : IOS_SJT_APP_URL;
  } else {
    return getMobileOperatingSystem() === "Android"
      ? ANDROID_APP_URL
      : IOS_APP_URL;
  }
};

export const TRY_APP_URL =
  getMobileOperatingSystem() === "Android" ? ANDROID_APP_URL : IOS_APP_URL;
